module.exports = __webpack_public_path__ + "img/linkedIn.381b1576.png";